import { render, staticRenderFns } from "./PolicyReviewCard.vue?vue&type=template&id=1d4e0e4e"
import script from "./PolicyReviewCard.vue?vue&type=script&lang=js"
export * from "./PolicyReviewCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports